import { NavigationTab } from 'shared/model';
import {
  MANUAL_COMMANDS,
  RESERVES,
  SESSION_LOG,
} from 'shared/consts/routes/common';
import { EVENTS, STATUSES } from 'shared/consts/routes/charge-point';

import { AddChargePointButtonLink } from 'entities/charge-point';

import { OpenManualCommandButton } from 'features/manual-command/ui/open-manual-command-modal-button';

export const CHARGE_POINT_TABS: Array<NavigationTab> = [
  {
    key: 'info',
    path: '',
    label: 'Информация об ЭЗС',
    buttons: [
      {
        element: <AddChargePointButtonLink />,
        controller: 'ChargePoint',
        right: 'Write',
      },
    ],
  },

  {
    key: SESSION_LOG,
    path: SESSION_LOG,
    label: 'Журнал сессий',
    controller: 'PrivateMethods',
    right: 'Read', //
    hasLoader: true,
  },
  {
    key: RESERVES,
    path: RESERVES,
    label: 'Журнал брони',
    controller: 'PrivateMethods',
    right: 'Read', //
  },
  {
    key: EVENTS,
    path: EVENTS,
    label: 'События',
    controller: 'PrivateMethods',
    right: 'Read', //
    hasLoader: true,
  },
  {
    key: MANUAL_COMMANDS,
    path: MANUAL_COMMANDS,
    label: 'Управление',
    controller: 'PrivateMethods',
    right: 'Read', //
    buttons: [
      {
        element: <OpenManualCommandButton />,
        controller: 'PrivateMethods',
        right: 'Execute',
      },
    ],
  },
  {
    key: STATUSES,
    path: STATUSES,
    label: 'Статусы',
    controller: 'PrivateMethods',
    right: 'Read', //
  },
];
